<template>
  <div>
    <div class="copy-dtx-table material-master-table--container" v-click-outside="closeWorkflowDropdown">
      <table>
        <thead v-if="view === 'material'">
          <tr>
            <th v-overflow-tooltip>Code</th>
            <th v-overflow-tooltip>ERP ID</th>
            <th v-overflow-tooltip>Name</th>
            <th v-overflow-tooltip>Type</th>
            <th v-overflow-tooltip>Material Group</th>
            <th v-overflow-tooltip>UOM</th>
            <th v-if="!isExternalCollaborator" v-overflow-tooltip>
              Process Plan/Lead Time
            </th>
            <th v-overflow-tooltip>Committed Inventory</th>
            <th v-overflow-tooltip>Total Inventory</th>
            <th
              v-overflow-tooltip
              v-if="
                !isOnProjectLevel  &&
                !isExternalCollaborator
              "
              :class="{ 'action-column-expanded': workFlowDropdownObject.index !== -1 }"
            >
              Action
            </th>
          </tr>
        </thead>
        <thead v-else>
          <tr>
            <th v-overflow-tooltip>Resource Name</th>
            <th v-overflow-tooltip>Type</th>
            <th v-overflow-tooltip>Setup Time</th>
            <th
              v-overflow-tooltip
              v-if="!isOnProjectLevel"
              :class="[
                'resource-action-header',
                { 'action-column-expanded': workFlowDropdownObject.index !== -1 }
              ]"
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!materialMasterList || materialMasterList.length === 0">
            <td :colspan="view === 'material' ? 10 : 8" class="no-data-cell">
              <div style="text-align: center; padding: 1rem">No Data Found</div>
            </td>
          </tr>
          <template v-if="view === 'material'">
            <tr
              v-for="(mm, index) in materialMasterList"
              :key="`material-${mm.id}`"
              class="pointer"
              :class="{ 'obsolete-row': mm.status === 2 }"
              @dblclick="(event)=>openDetailModal(event, index)"
            >
              <td class="relative pointer" v-overflow-tooltip>
                <div class="v-center">
                  <div class="chip-popover v-center h-center" v-if="mm.thumbnailUrl">
                    <img :src="mm.thumbnailUrl" alt="Material Thumbnail" />
                  </div>

                  <div class="elipsis-text" v-overflow-tooltip>
                    {{ mm.custom_material_id || "--" }}
                  </div>
                </div>

                <div
                  v-if="mm?.material_product_code?.product_code"
                  class="pt-3 elipsis-text vendorName"
                  v-overflow-tooltip
                >
                  Prod: {{ mm?.material_product_code?.product_code }}
                </div>
              </td>
              <td class="elipsis-text" v-overflow-tooltip>
                {{ mm.erp_material_id || "--" }}
              </td>
              <td>
                <div class="material-name-cell">
                  <div
                  :key="`status-${mm.status}`"
                  v-tooltip="getStatusTooltip(mm.status)"
                  :class="['material-status', getStatusClass(mm.status)]"
                ></div>
                <div class="elipsis-text material-name" v-overflow-tooltip>
                  {{ mm.material_name || "--" }}
                </div>
                <div class="pt-3 elipsis-text vendorName material-description" v-overflow-tooltip>
                  {{ mm?.material_description }}
                </div>
                  </div>
              </td>
              <td class="elipsis-text" v-overflow-tooltip>
                <span :class="getTypeClass(mm?.material_type_value?.name)">{{
                  mm?.material_type_value?.name
                }}</span>
              </td>
              <td class="elipsis-text" v-overflow-tooltip>
                {{ mm?.material_group_details?.name || "--" }}
              </td>
              <td
                :class="{
                  redColor: !list_of_unit_of_material[mm.unit_of_material],
                }"
                v-overflow-tooltip
              >
                {{ mm.material_unit_details.name || "--" }}
              </td>
              <td v-if="!isExternalCollaborator" v-overflow-tooltip>
                <div
                  class="elipsis-text"
                  style="font-size: var(--text-xs1)"
                  :style="{ color: '#0606f6' }"
                  v-overflow-tooltip
                >
                  {{ materialMasterList[index]?.workflow_template?.name }}
                </div>
                <div class="pt-3" :style="{ color: '#686464' }">
                  {{ mm.lead_time || "--" }} {{ mm.lead_time ? "day" : "" }}
                </div>
                <div class="vendor-container">
                  <label class="vendorName elipsis-text" v-overflow-tooltip>
                    {{ mm?.material_default_vendor?.company_name }}
                  </label>
                  <img
                    v-if="
                      !isExternalCollaborator &&
                      Array.isArray(mm.vendor_materials) &&
                      mm.vendor_materials.length &&
                      showEditButton
                    "
                    class="editVendor"
                    v-tooltip="'Edit'"
                    src="~@/assets/images/pencil.svg"
                    alt=""
                    @click.stop="openVendorModal(mm)"
                  />
                </div>
              </td>
              <td
                class="inventory-cell"
                v-overflow-tooltip
                @click.stop="openInventoryModal(mm)"
              >
                <span
                  v-if="mm?.inventory !== null && mm?.inventory !== undefined"
                  class="inventory-link"
                >
                  {{ mm.inventory }}
                </span>
                <span v-else>--</span>
              </td>
              <td class="elipsis-text" v-overflow-tooltip>
                <span v-if="mm?.inventory !== null && mm?.inventory !== undefined">{{
                  mm.inventory
                }}</span>
                <span v-else>--</span>
              </td>
              <td
                class="action-column column overflow-visible"
                :class="{ 'action-column-expanded': workFlowDropdownObject.index === index }"
                v-if="
                  !isOnProjectLevel  &&
                  !isExternalCollaborator
                "
                @click.stop
              >
                <div
                  v-show="workFlowDropdownObject.index === index && !isOnProjectLevel"
                  class="v-center workflow-link-editor"
                >
                  <custom-dropdown
                    :list="filteredWorkflows"
                    :selected="selectedWorkFlow"
                    @select="handleWorkFlowSelection"
                    @toggle="() => (workflowSearchKeyword = '')"
                    @deselect="handleWorkFlowSelection"
                    class="wft"
                  >
                    <template #before-items>
                      <div
                        class="fh center py-4"
                        v-if="WFTLoading && workflows.length === 0"
                      >
                        <loading-circle />
                      </div>
                      <div
                        class="fh block p-3 py-4 elipsis-text"
                        v-else-if="!WFTLoading && workflows.length === 0"
                        v-overflow-tooltip
                      >
                        No Workflow Templates
                      </div>
                      <div class="fh center p-3 wft-search-box" v-else @click.stop>
                        <input
                          type="text"
                          class="wft-input"
                          v-model="workflowSearchKeyword"
                          placeholder="Search"
                        />
                      </div>
                      <div
                        class="fh block p-3 elipsis-text py-4"
                        v-if="workflows.length !== 0 && filteredWorkflows.length === 0"
                        v-overflow-tooltip
                      >
                        No Workflow Templates
                      </div>
                    </template>
                  </custom-dropdown>
                  <img
                    v-show="workFlowDropdownObject.index === index"
                    v-tooltip="'Cancel'"
                    @click.stop="closeWorkflowDropdown"
                    src="~@/assets/images/icons/close-icon.svg"
                    alt=""
                    class="edit"
                  />
                  <img
                    v-show="workFlowDropdownObject.index === index"
                    v-tooltip="'Save'"
                    @click.stop="updateWorkflowLink"
                    src="~@/assets/images/icons/save-icon.svg"
                    alt=""
                    class="edit"
                  />
                </div>
                <div
                  class="action-icons"
                  v-show="workFlowDropdownObject.index !== index"
                >
                <!-- edit material icon start  -->
                  <img
                    v-if="notViewer"
                    :class="['edit', { 'is-disabled': isEditDisabled(mm) }]"
                    @click.stop="!isEditDisabled(mm) && openEditModal(index)"
                    v-tooltip="getEditTooltip(mm)"
                    src="~@/assets/images/pencil.svg"
                    alt=""
                  />
                <!-- edit material  end  -->
                <!-- link material icon start -->
                    <img
                     v-if="notViewer"
                    :class="['edit', { 'is-disabled': isLinkWorkflowDisabled(mm) }]"
                    @click.stop="!isLinkWorkflowDisabled(mm) && openWorkflowDropdown(index)"
                    v-tooltip="getLinkWorkflowTooltip(mm)"
                    :src="
                      mm.workflow_template
                        ? require('@/assets/images/icons/link-icon.svg')
                        : require('@/assets/images/icons/add-link.svg')
                    "
                    alt=""
                  />
                <!-- link material icon end -->
                <div class="action-menu"  v-if="notViewer">
                  <action-dropdown
                    :items="getLifecycleActions(mm, index)"
                    :disabled="isLifecycleDisabled(mm, index)"
                    title="Actions"
                    @select="(action) => handleLifecycleAction(action, mm, index)"
                  >
                    <template #trigger>
                      <img
                        :class="['edit', { 'is-disabled': isLifecycleDisabled(mm, index) }]"
                        v-tooltip="getLifecycleTooltip(mm, index)"
                        src="~@/assets/images/icons/status-change.svg"
                        alt="Status Change"
                        width="15"
                      />
                    </template>
                  </action-dropdown>
                  </div>
                  <!-- history icon start  -->
                  <img
                    :class="['edit']"
                    @click.stop="openMaterialHistoryModal(index)"
                    v-tooltip="'History'"
                    src="~@/assets/images/icons/history-icon.svg"
                    alt="Show history"
                  />
                  <!-- history icon end  -->

                  <!-- <img
                    :class="['edit', { 'is-template': mm.workflow_template }]"
                    v-show="showAlternateButton && (mm.status === 3 || mm.status === 1)"
                    @click.stop="openAlternateModal(mm)"
                    v-tooltip="'Alternate Material'"
                    src="~@/assets/images/icons/alternate-link.svg"
                    alt="Manage alternates"
                  /> -->
                  <!-- <img
                    v-show="showUnLockButton && mm.status === 4"
                    @click.stop="openChangeStatusModal(index, 'unlock')"
                    v-tooltip="'Unlock material'"
                    src="~@/assets/images/icons/unlock-icon.svg"
                    alt=""
                    class="mx-1 pointer edit edit-1"
                    width="16"
                  /> -->
                  <!-- <img
                    v-show="showObsoleteButton && mm.status === 1"
                    @click.stop="openMaterialObsoleteModal(index)"
                    v-tooltip="'Make material Obsolete'"
                    src="~@/assets/images/trash-2.svg"
                    alt=""
                    class="pointer edit edit-1"
                    width="16"
                  /> -->
                  <!-- <img
                    v-show="showActiveButton && mm.status === 2"
                    @click.stop="openChangeStatusModal(index, 'activate')"
                    v-tooltip="'Make material Active'"
                    src="~@/assets/images/icons/undo-icon.svg"
                    alt=""
                    class="pointer edit edit-1"
                    width="16"
                  /> -->
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr
              v-for="(res, index) in materialMasterList"
              :key="res.id"
              class="pointer"
              @dblclick="(event)=>openDetailModal(event, index)"
            >
              <td>
               <div class="material-name-cell">
                  <div
                  :key="`status-${res.status}`"
                  v-tooltip="getStatusTooltip(res.status)"
                  :class="['material-status', getStatusClass(res.status)]"
                ></div>
                <div class="elipsis-text material-name" v-overflow-tooltip>
                  {{ res.material_name || "--" }}
                </div>
                <div class="pt-3 elipsis-text vendorName material-description" v-overflow-tooltip>
                  {{ res?.material_description }}
                </div>
                  </div>
              </td>
              <td>
                <span :class="getResourceTypeClass(res.resource_type_value?.name)">
                  {{ res.resource_type_value?.name ?? "--" }}
                </span>
              </td>
              <td>
                <span v-if="res.setup_time !== null && res.setup_time !== undefined">
                  {{ res.setup_time }}
                  {{ Config.DURATION_TYPE[res.setup_time_duration_type] }}
                </span>
                <span v-else>--</span>
              </td>
              <td
                class="action-column column overflow-visible"
                :class="{ 'action-column-expanded': workFlowDropdownObject.index === index }"
                v-if="
                  !isOnProjectLevel &&
                  !isExternalCollaborator
                "
                @click.stop
              >
                <div
                  v-show="workFlowDropdownObject.index === index && !isOnProjectLevel"
                  class="v-center workflow-link-editor"
                >
                  <custom-dropdown
                    :list="filteredWorkflows"
                    :selected="selectedWorkFlow"
                    @select="handleWorkFlowSelection"
                    @toggle="() => (workflowSearchKeyword = '')"
                    @deselect="handleWorkFlowSelection"
                    class="wft"
                  >
                    <template #before-items>
                      <div
                        class="fh center py-4"
                        v-if="WFTLoading && workflows.length === 0"
                      >
                        <loading-circle />
                      </div>
                      <div
                        class="fh block p-3 py-4 elipsis-text"
                        v-else-if="!WFTLoading && workflows.length === 0"
                        v-overflow-tooltip
                      >
                        No Workflow Templates
                      </div>
                      <div class="fh center p-3 wft-search-box" v-else @click.stop>
                        <input
                          type="text"
                          class="wft-input"
                          v-model="workflowSearchKeyword"
                          placeholder="Search"
                        />
                      </div>
                      <div
                        class="fh block p-3 elipsis-text py-4"
                        v-if="workflows.length !== 0 && filteredWorkflows.length === 0"
                        v-overflow-tooltip
                      >
                        No Workflow Templates
                      </div>
                    </template>
                  </custom-dropdown>
                  <img
                    v-show="workFlowDropdownObject.index === index"
                    v-tooltip="'Cancel'"
                    @click.stop="closeWorkflowDropdown"
                    src="~@/assets/images/icons/close-icon.svg"
                    alt=""
                    class="edit"
                  />
                  <img
                    v-show="workFlowDropdownObject.index === index"
                    v-tooltip="'Save'"
                    @click.stop="updateWorkflowLink"
                    src="~@/assets/images/icons/save-icon.svg"
                    alt=""
                    class="edit"
                  />
                </div>
                <div
                  :class="[
                    'action-icons',
                    { 'resource-action-icons': view === 'resource' },
                  ]"
                  v-show="workFlowDropdownObject.index !== index"
                >
                    <img
                     v-if="notViewer"
                    :class="['edit', { 'is-disabled': isEditDisabled(res) }]"
                    @click.stop="!isEditDisabled(res) && openEditModal(index)"
                    v-tooltip="getEditTooltip(res)"
                    src="~@/assets/images/pencil.svg"
                    alt=""
                  />
                    <img
                    :class="['edit']"
                    @click.stop="openMaterialHistoryModal(index)"
                    v-tooltip="'History'"
                    src="~@/assets/images/icons/history-icon.svg"
                    alt="Show history"
                  />
                  <!-- <img
                    :class="['edit', { 'is-template': res.workflow_template }]"
                    v-show="showAlternateButton && (res.status === 3 || res.status === 1)"
                    @click.stop="openAlternateModal(res)"
                    v-tooltip="'Alternate Material'"
                    src="~@/assets/images/icons/alternate-link.svg"
                    alt="Manage alternates"
                  /> -->
                  <!-- <img
                    v-show="showLockButton && res.status === 1"
                    @click.stop="openChangeStatusModal(index, 'lock')"
                    v-tooltip="'Lock material'"
                    src="~@/assets/images/icons/locked-icon-black.svg"
                    alt=""
                    class="mx-1 pointer edit"
                    width="16"
                  />
                  <img
                    v-show="showUnLockButton && res.status === 4"
                    @click.stop="openChangeStatusModal(index, 'unlock')"
                    v-tooltip="'Unlock material'"
                    src="~@/assets/images/icons/unlock-icon.svg"
                    alt=""
                    class="mx-1 pointer edit edit-1"
                    width="16"
                  /> -->
                  <!-- <img
                    v-show="showObsoleteButton && res.status === 1"
                    @click.stop="openMaterialObsoleteModal(index)"
                    v-tooltip="'Make material Obsolete'"
                    src="~@/assets/images/trash-2.svg"
                    alt=""
                    class="pointer edit edit-1"
                    width="16"
                  /> -->
                  <!-- <img
                    v-show="showActiveButton && res.status === 2"
                    @click.stop="openChangeStatusModal(index, 'activate')"
                    v-tooltip="'Make material Active'"
                    src="~@/assets/images/icons/undo-icon.svg"
                    alt=""
                    class="pointer edit edit-1"
                    width="16"
                  /> -->
                </div>
              </td>

              <!-- <td
                v-if="!isOnProjectLevel && user.tenantLevelRole !== 'VIEWER'"
                @click.stop
              >
                <div class="action-icons">
                  <img
                    v-show="showEditButton"
                    src="~@/assets/images/pencil.svg"
                    class="edit"
                    @click.stop="openEditModal(index)"
                  />
                </div>
              </td> -->
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="flex space-between">
      <pagination-2
        class="mt-4"
        :length="totalCount"
        :pageNumber="pageNumber"
        :perPage="perPage"
        @selectPage="$emit('selectPage', $event)"
      />
      <div class="total-count mt-4">
        <span
          >Total {{ view === "material" ? "Materials" : "Resources" }} : &nbsp;
          <b>{{ totalCount }}</b></span
        >
      </div>
    </div>
    <right-slide-modal
      @close="closeDetailModal"
      :open="detailModalObject?.isOpen"
      :closeOnOutsideClick="true"
    >
      <template #header>
        <item-master-header
          :materialMaster="detailModalObject.selectedMaterialObj"
          :view="view"
        />
      </template>
      <item-master-detail-view
        :materialMaster="detailModalObject.selectedMaterialObj"
        :view="view"
        :initialTab="detailModalObject.activeTab"
      />
    </right-slide-modal>
    <modal
      @close="closeEditModal"
      :open="editModalObject?.isOpen"
      :title="view === 'material' ? 'Update Material Master' : 'Update Resource Master'"
    >
      <edit-mateterial-master
        @close="closeEditModal"
        :resourceState="this.resourceStateValues.find((r) => r.name === 'IDLE')"
        :view="view"
        @updateAndClose="updateAndClose"
        v-if="editModalObject.selectedIndex !== -1"
        :materialMaster="materialMasterList[editModalObject.selectedIndex]"
      />
    </modal>
    <alternateMaterialModal
      v-if="showAlternateModal"
      :item="selectedMaterial"
      :all-items="allMaterials"
      :approval-plan="workflowSteps"
      size="lg"
      @close="closeAlternateModal"
      @add-alternate="handleAddAlternate"
      @view-alternate="handleViewAlternate"
      @validation-error="handleValidationError"
    />
    <modal
      @close="closeMaterialObsoleteModal"
      :open="materialObsoleteObject?.isOpen"
      :title="
        view === 'material'
          ? 'Are you sure you want to make the material obsolete'
          : 'Are you sure you want to make the resource obsolete'
      "
    >
      <div v-if="materialObsoleteObject.selectedIndex !== -1">
        <span
          >Making the {{ view === "material" ? "material" : "resource" }}
          <span class="weight-600">{{
            materialMasterList[materialObsoleteObject.selectedIndex].material_name
          }}</span>
          as obsolete will impact the boms associated with this
          {{ view === "material" ? "material" : "resource" }}</span
        >
        <span class="productbom-title block mt-4"
          >Products and BOMS where this
          {{ view === "material" ? "material" : "resource" }} is used:</span
        >
        <associated-bom-table
          :loading="false"
          :productsAndBoms="materialObsoleteObject.productsAndBoms"
        />
        <div class="flex flex-end py-3 m">
          <button class="btn btn-black mr-3" @click="closeMaterialObsoleteModal">
            CANCEL
          </button>
          <button class="btn" @click="confirmMaterialObsolete">CONFIRM</button>
        </div>
      </div>
    </modal>
    <modal @close="vendorObject.isOpen = false" :open="vendorObject.isOpen">
      <h2 class="modal-title">Select Default Vendor</h2>
      <p class="modal-subtitle">
        <span :style="{ color: '#c9a26c' }">Choose default vendor for</span>
        <strong> &nbsp; {{ vendorObject.materialName }}</strong>
      </p>
      <div v-if="!isExternalCollaborator" class="vendor-card-container">
        <div
          class="vendor-card default-vendor"
          v-for="(vendor, key) in vendorObject.vendorList"
          :key="key"
          @click="selectVendor(vendor.tenant_company_association.target_tenant.id)"
        >
          <div class="card-icon-check">
            <span
              class="radio"
              :class="{
                checked:
                  selectedVendor === vendor.tenant_company_association.target_tenant.id,
              }"
            ></span>
          </div>

          <div class="card-details">
            <div class="card-header">
              <span class="vendor-name">{{
                vendor.tenant_company_association.target_tenant.company_name
              }}</span>
            </div>
            <div class="logistics-info">
              <div class="logistics-item">
                <span class="label">Lead Time</span>
                <span class="value">{{ vendor.lead_time }}</span>
              </div>
              <div class="logistics-item">
                <span class="label">MOQ</span>
                <span class="value">{{ vendor.moq }} units</span>
              </div>
            </div>
            <div class="pricing-tiers">
              <span class="label">Pricing Tiers</span>
              <div
                class="tiers-list"
                v-for="(item, key) in vendor.vendor_materials_pricing_tiers"
                :key="key"
              >
                <p>
                  ₹{{ item.unit_price }}/ unit {{ item.min_quantity }} -
                  {{ item.max_quantity }},
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="selectedVendor === vendor.tenant_company_association.target_tenant.id"
          >
            <span class="current-default">● Current Default</span>
          </div>
        </div>
      </div>
      <div class="flex flex-end pt-10 m">
        <button class="btn btn-white mr-3 pointer" @click="vendorObject.isOpen = false">
          Cancel
        </button>
        <button class="btn pointer" @click="updateDefaultVendor">Set as default</button>
      </div>
    </modal>
    <attached-doc-view
      v-if="detailObject.open"
      :linkedDocs="detailObject.linkedDocs"
      @close="closeDetail"
    />
    <material-inventory-modal
      :open="showInventoryModal"
      :materialId="selectedInventoryMaterial?.id"
      :materialName="selectedInventoryMaterial?.name"
      :totalQuantity="selectedInventoryMaterial?.inventory"
      @close="closeInventoryModal"
    />
    <!--  history modal starts  -->
    <modal
      @close="historyModal = false"
      :open="historyModal"
      :title="view === 'material' ? 'Material History' : 'Resource History'"
    >
      <div class="material-history-container">
        <div v-if="historyLoader" class="fh fw center loader-conatainer">
          <loading-circle />
        </div>
        <!-- history start  -->
        <i
          v-else-if="!Object.keys(materialHistory).length"
          class="material-history-box p-3 center"
        >
          History is not available
        </i>
        <div v-else  class="material-history-box">
          <div
            v-for="(dateArray, index) in materialHistory"
            class="material-history-body"
            :key="index"
          >
            <div class="material-history-body-dateBox">
              <div class="material-history-body-date">
                <img src="~@/assets/images/icons/calenderGrey.svg" width="12px" alt="" />
                {{ dateArray[0].timestamp | timeStampToDate }}
              </div>
              <hr class="material-history-body-date-line" />
            </div>
            <div class="material-history-body-elementsBox">
              <history-element
                v-for="(item, index) in dateArray"
                :key="index"
                :data="item"
                :elementColor="'238, 159, 214'"
              />
            </div>
          </div>
          <!-- history end  -->
        </div>
      </div>
    </modal>
    <!--  history modal ends  -->

    <!--  wf-selection modal starts  -->
    <modal
      @close="wfSelectionModal = false"
      :open="wfSelectionModal"
      :title="'Change Material Status'"
    >
      <div  class="material-history-container">
        <div v-if="wfSelectionLoader.loader" class="fh fw center loader-conatainer">
          <loading-circle />
        </div>
      <wf-selection-lifecycle v-else
      :workflows="workflowsData"
      :feature="{ name:'material', id: selectedMaterialForLC.id, data: selectedMaterialForLC}"
      :wfModalLoaderController="wfModalLoaderController"
      :cancel="cancelWfSelectionModal"
      :emitChanges="emitChanges"
      :panelStyle="'flat'"
      :workflowLoading="wfSelectionLoader.skelton"
      :showManualStatusChange="showStatusChangeOptions"
        >
       <template
         #actions="{
           statusChangeMode
         }"
       >
      <div v-if="statusChangeMode === 'manual'  && showStatusChangeOptions" class="wf-status-action fh fw">
        <p class="wf-status-action__title">Target Status</p>
        <div class="wf-status-action__grid">
          <button
          v-if="showActivateBtn"
            type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === Config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE }
            ]"
            @click="setSelectedTargetStatus(Config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE)"
          >
            ACTIVE
          </button>
          <!-- <button
          v-if="showHoldBtn"
            type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === Config.MATERIAL_STATUS_INVERTED_MAP.HOLD }
            ]"
            @click="setSelectedTargetStatus(Config.MATERIAL_STATUS_INVERTED_MAP.HOLD)"
          >
            HOLD
          </button> -->
          <button
          v-if="showLockBtn"
            type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active':selectedTargetStatus === Config.MATERIAL_STATUS_INVERTED_MAP.LOCKED }
            ]"
            @click="setSelectedTargetStatus(Config.MATERIAL_STATUS_INVERTED_MAP.LOCKED)"
          >
            LOCKED
          </button>
          <button
          v-if="showReleaseBtn"
            type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === Config.MATERIAL_STATUS_INVERTED_MAP.RELEASED }
            ]"
            @click="setSelectedTargetStatus(Config.MATERIAL_STATUS_INVERTED_MAP.RELEASED)"
          >
            RELEASED
          </button>
          <button
          v-if="showObsoleteBtn"
            type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === Config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE }
            ]"
            @click="setSelectedTargetStatus(Config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE)"
          >
            OBSOLETE
          </button>
        </div>
        <div class="wf-status-action__footer gap-1">
          <button class="btn" @click="proceedWithManualStatusChange">Change</button>
        </div>
      </div>
       </template>
       </wf-selection-lifecycle>
      </div>
    </modal>
    <!--  wf-selection modal ends  -->

    <!-- workflow instance modal start  -->
    <modal
      @close="workflowInstanceModal = false"
      :open="workflowInstanceModal"
      :title="view === 'material' ? 'Update Material Master' : 'Update Resource Master'"
    >
                  <workflow-instance-edit-panel
                    :panel-style="'alternate'"
                    v-if="selectedMaterialForLC.ongoing_lifecycle_workflow_id && workflowInstanceModal"
                    ref="WorkflowDetailsPanel"
                    :wfInstanceId="selectedMaterialForLC.ongoing_lifecycle_workflow_id"
                    :feature="Config.WORKFLOW_SUB_CATE.LIFECYCLE"
                    @goBack="workflowInstanceModal = false"
                    @finishWorkflow="finishWorkflow"
                    @afterWFaction="afterWFAction"
                    @workflowHistoryUpdated="checkAndUpddateMaterialStatus"
                    @workflowCancelled="workflowCancelled"
                  />
    </modal>
    <!-- workflow instance modal  end  -->
  </div>
</template>

<script>
import {
  GetProductsUsingMaterialQuery,
  UnitOfMaterial,
  ResourceState,
  ChangeResourceStatus,
  GetMaterialMasterData,
  getFullWorkFLowTemplates,
  UpdateMaterialWorkflowLink,
  checkForAnyRunningInstances,
  updatedefaultVenodor,
  getWfListBasedOnId,
  lifeCycleStatusUpdate
} from '@/api'
import Modal from '../common/modal.vue'
import RightSlideModal from '../common/rightSlideModal.vue'
import alternateMaterialModal from './alternateMaterialModal.vue'
import pagination2 from '../common/pagination2.vue'
import AssociatedBomTable from './associatedBomTable.vue'
import ItemMasterDetailView from './itemMasterDetailView.vue'
import ItemMasterHeader from './itemMasterViewComponents/ItemMasterHeader.vue'
import EditMateterialMaster from './editMateterialMaster.vue'
import MaterialInventoryModal from './materialInventoryModal.vue'
import ConfirmationDialog from '@/plugins/confirmationDialog'
import HistoryElement from '@/views/FORM/historyElement.vue'
import { success, alert } from '@/plugins/notification'
import Loader from '@/plugins/loader'
import AttachedDocView from '../../components/document/attachedDocView.vue'
import { mapGetters } from 'vuex'
import CustomDropdown from '../common/customDropdown.vue'
import ActionDropdown from '../common/actionDropdown.vue'
import wfSelectionLifecycle from '../workflows/wfSelectionLifecycle.vue'
import loadingCircle from '../common/loadingCircle.vue'
import { timeStampToDateTime } from '@/filters/dateFilter'
import Config from '@/config'
import statusChangeIcon from '@/assets/images/icons/status-change.svg'
import alternateIcon from '@/assets/images/icons/alternate-link.svg'
import workflowIcon from '@/assets/images/icons/workflows.svg'
import workflowInstanceEditPanel from '@/views/FORM/workflowInstanceEditPanel.vue'

export default {
  components: {
    pagination2,
    Modal,
    RightSlideModal,
    ItemMasterDetailView,
    ItemMasterHeader,
    HistoryElement,
    EditMateterialMaster,
    AssociatedBomTable,
    AttachedDocView,
    CustomDropdown,
    ActionDropdown,
    loadingCircle,
    MaterialInventoryModal,
    alternateMaterialModal,
    wfSelectionLifecycle,
    workflowInstanceEditPanel
  },
  name: 'materialMasterTable',
  props: {
    view: {
      type: String,
      default: 'material'
    },
    materialMasterList: {
      type: Array,
      default: () => []
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  filters: {
    timeStampToDateTime,
    timeStampToDate (timestamp) {
      return new Date(timestamp).toLocaleDateString('en-US', {
        weekday: 'long', // Sunday
        month: 'short', // Jul
        day: 'numeric' // 20
      })
    }
  },
  data: () => ({
    selectedWorkFlow: null,
    showAlternateModal: false,
    selectedMaterial: null,
    allMaterials: [],
    workflowSteps: [],
    WFTLoading: false,
    workflows: [],
    workflowSearchKeyword: '',
    workFlowDropdownObject: {
      index: -1,
      open: false
    },
    resourceStateValues: [],
    detailModalObject: {
      isOpen: false,
      selectedIndex: -1,
      selectedMaterialObj: null,
      activeTab: 'details'
    },
    editModalObject: {
      isOpen: false,
      selectedIndex: -1
    },
    materialObsoleteObject: {
      isOpen: false,
      selectedIndex: -1,
      productsAndBoms: null
    },
    showInventoryModal: false,
    selectedInventoryMaterial: null,
    detailObject: {
      open: false,
      linkedDocs: []
    },
    popoverIndex: null,
    list_of_unit_of_material: {},
    Config: Config,
    vendorObject: {
      isOpen: false,
      vendorList: null,
      materialId: null
    },
    historyLoader: false,
    historyModal: false,
    materialHistory: {},
    wfSelectionModal: false,
    wfSelectionLoader: { loader: false, skelton: false },
    workflowsData: [],
    selectedMaterialForLC: {},
    selectedTargetStatus: '',
    workflowInstanceModal: false
  }),
  computed: {
    ...mapGetters(['user', 'getUserById']),
    ...mapGetters([
      'isTenantAdmin',
      'isProjectAdmin',
      'isTenantViewer',
      'isProjectViewer',
      'isOnProjectLevel',
      'collaborator',
      'isExternalCollaborator'
    ]),
    filteredWorkflows () {
      if (!this.workflowSearchKeyword.length) return this.workflows
      return this.workflows.filter((item) => {
        return item.name.toLowerCase().includes(this.workflowSearchKeyword.toLowerCase())
      })
    },
    availableMaterials () {
      if (!this.selectedMaterial || !this.materialMasterList) {
        return this.materialMasterList || []
      }
      return this.materialMasterList.filter((m) => m.id !== this.selectedMaterial.id)
    },
    showAlternateButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR') &&
        !this.isOnProjectLevel &&
        !this.collaborator &&
        this.view === 'material'
      )
    },
    showEditButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR' ||
          this.user.tenantLevelRole === 'EDITOR') &&
        !this.isOnProjectLevel &&
        !this.collaborator
      )
    },
    showLockButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR') &&
        !this.isOnProjectLevel &&
        !this.collaborator &&
        this.view === 'material'
      )
    },
    showUnLockButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR') &&
        !this.isOnProjectLevel &&
        !this.collaborator &&
        this.view === 'material'
      )
    },
    showObsoleteButton () {
      return (
        this.user.tenantLevelRole === 'ADMIN' &&
        !this.isOnProjectLevel &&
        !this.collaborator &&
        this.view === 'material'
      )
    },
    showActiveButton () {
      return (
        this.user.tenantLevelRole === 'ADMIN' &&
        !this.isOnProjectLevel &&
        !this.collaborator &&
        this.view === 'material'
      )
    },
    showActivateBtn () {
      if (!this.selectedMaterialForLC?.id) {
        return false
      }
      return (
        (this.user.tenantLevelRole === 'ADMIN' || this.user.tenantLevelRole === 'COLLABORATOR') && [Config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE, Config.MATERIAL_STATUS_INVERTED_MAP.LOCKED, Config.MATERIAL_STATUS_INVERTED_MAP.RELEASED].includes(this.selectedMaterialForLC.status)
      )
    },
    showHoldBtn () {
      if (!this.selectedMaterialForLC?.id) {
        return false
      }
      return (
        this.user.tenantLevelRole === 'ADMIN' && [Config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE, Config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE, Config.MATERIAL_STATUS_INVERTED_MAP.RELEASED].includes(this.selectedMaterialForLC.status)
      )
    },
    showObsoleteBtn () {
      if (!this.selectedMaterialForLC?.id) {
        return false
      }
      return (
        this.user.tenantLevelRole === 'ADMIN' && [Config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE, Config.MATERIAL_STATUS_INVERTED_MAP.LOCKED].includes(this.selectedMaterialForLC.status)
      )
    },
    showLockBtn () {
      if (!this.selectedMaterialForLC?.id) {
        return false
      }
      return (
        (this.user.tenantLevelRole === 'ADMIN' || this.user.tenantLevelRole === 'COLLABORATOR') && [Config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE].includes(this.selectedMaterialForLC.status)
      )
    },
    showReleaseBtn () {
      if (!this.selectedMaterialForLC?.id) {
        return false
      }
      return (
        this.user.tenantLevelRole === 'ADMIN' && [Config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE, Config.MATERIAL_STATUS_INVERTED_MAP.LOCKED].includes(this.selectedMaterialForLC.status)
      )
    },
    notViewer () {
      return this.user.tenantLevelRole !== 'VIEWER'
    },
    showStatusChangeOptions () {
      return this.showActivateBtn || this.showObsoleteBtn || this.showLockBtn || this.showReleaseBtn
    }
  },
  methods: {
    selectVendor (id) {
      this.selectedVendor = id
    },
    isEditDisabled (item) {
      if (item.type === Config.MATERIAL_TYPE_INVERTED.RESOURCE) {
        return !this.showEditButton
      }
      if (!this.showEditButton || !item.canEdit) return true
      if (!(item.status === 3 || item.status === 1)) return true
      return Boolean(item?.job_order_material_links?.length)
    },
    getEditTooltip (item) {
      const label = this.view === 'resource' ? 'Edit Resource' : 'Edit Material'
      if (!this.showEditButton) return 'You do not have permission to edit.'
      if (item.status !== Config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE) return 'Edit is available only for status ACTIVE.'
      if (this.view === 'material' && !item.canEdit) return 'Material is going through lifecycle changes, you are not part of the workflow step assignee or user group.'
      if (item?.job_order_material_links?.length) return 'Material is attached to JOF.'
      return label
    },
    isLinkWorkflowDisabled (mm) {
      if (!this.isTenantAdmin) return true
      if (this.isOnProjectLevel) return true
      if (!(mm.status === 3 || mm.status === 1)) return true
      return mm?.material_type_value?.name === 'Buy'
    },
    getLinkWorkflowTooltip (mm) {
      if (!this.isTenantAdmin) return 'Only tenant admins can link workflows.'
      if (this.isOnProjectLevel) return 'Workflow linking is not available at project level.'
      if (!(mm.status === 3 || mm.status === 1)) return 'Link workflow is available only for status ACTIVE or HOLD.'
      if (mm?.material_type_value?.name === 'Buy') return 'Can\'t link process to bought out item.'
      return 'Link workflow'
    },
    isLifecycleDisabled (mm, index) {
      if (!this.notViewer) return true
      const actions = this.getLifecycleActions(mm, index)
      if (!actions.length) return true
      return actions.every((action) => action.disabled)
    },
    getLifecycleTooltip (mm, index) {
      if (!this.notViewer) return 'You do not have permission to access actions.'
      const actions = this.getLifecycleActions(mm, index)
      if (!actions.length) return 'No actions available for this material.'
      if (actions.every((action) => action.disabled)) return 'No active actions available for this material.'
      return 'Actions'
    },
    getLifecycleActions (mm, index) {
      const actions = [
        {
          id: 'change-status',
          label: 'Change Status',
          icon: statusChangeIcon,
          payload: { mm, index },
          disabled: mm.ongoing_lifecycle_workflow_id
        }
      ]
      if (mm.ongoing_lifecycle_workflow_id) {
        actions.push({
          id: 'workflow-progression',
          label: 'Ongoing Workflow',
          icon: workflowIcon,
          payload: { mm, index }
        })
      }
      if (this.showAlternateButton && (mm.status === 3 || mm.status === 1)) {
        actions.push({
          id: 'manage-alternates',
          label: 'Manage Alternates',
          icon: alternateIcon,
          payload: { mm, index }
        })
      }

      return actions
    },
    handleLifecycleAction (action, mm, index) {
      switch (action.id) {
      case 'change-status':
        this.openWorkflowSelectionModal(mm, index)
        break
      case 'manage-alternates':
        this.openAlternateModal(mm)
        break
      case 'vendor-approval':
        this.openVendorModal(mm)
        break
      case 'workflow-progression':
        this.openWFInstanceModal(mm)
        break
      default:
        break
      }
    },
    updateWorkflowLink () {
      if (!this.selectedWorkFlow) {
        return alert('Select a workflow before save')
      }
      const workflowId = this.selectedWorkFlow ? this.selectedWorkFlow.id : null
      if (!workflowId) {
        checkForAnyRunningInstances(this.workFlowDropdownObject.id)
          .then((res) => {
            if (res?.job_order_material_links?.length) {
              alert("Item in JO form can't be modified")
              this.closeWorkflowDropdown()
              return
            }
            UpdateMaterialWorkflowLink(this.workFlowDropdownObject.id, workflowId)
              .then((res) => {
                const materialMasterTemp = JSON.parse(
                  JSON.stringify(
                    this.$props.materialMasterList[this.workFlowDropdownObject.index]
                  )
                )
                materialMasterTemp.workflow_template = this.selectedWorkFlow
                const index = this.workFlowDropdownObject.index
                this.$emit('updateList', {
                  data: materialMasterTemp,
                  index
                })
                success('Workflow linked successfully')
              })
              .catch(() => {
                alert('Unable to link workflow')
              })
              .finally(() => {
                this.closeWorkflowDropdown()
              })
          })
          .catch(() => {
            alert('Unable to fetch')
          })
      } else {
        UpdateMaterialWorkflowLink(this.workFlowDropdownObject.id, workflowId)
          .then((res) => {
            const materialMasterTemp = JSON.parse(
              JSON.stringify(
                this.$props.materialMasterList[this.workFlowDropdownObject.index]
              )
            )
            materialMasterTemp.workflow_template = this.selectedWorkFlow
            const index = this.workFlowDropdownObject.index
            this.$emit('updateList', {
              data: materialMasterTemp,
              index
            })
            success('Workflow linked successfully')
          })
          .catch(() => {
            alert('Unable to link workflow')
          })
          .finally(() => {
            this.closeWorkflowDropdown()
          })
      }
    },
    handleWorkFlowSelection (workflow) {
      this.selectedWorkFlow = workflow
    },
    getWorkflows () {
      this.WFTLoading = true
      getFullWorkFLowTemplates([Config.CORE_FEATURES.MATERIAL], '', [Config.WORKFLOW_SUB_CATE.PROCESS_PLAN])
        .then((res) => {
          if (res.workflow_templates) {
            this.workflows = res.workflow_templates.filter(
              (workflow) => workflow.system_generated !== true
            )
          }
        })
        .catch(() => {
          this.workflows = []
        })
        .finally(() => {
          this.WFTLoading = false
        })
    },
    // Add this to your methods object
    getResourceTypeClass (type) {
      switch (type) {
      case 'MACHINE':
        return 'type-machine'
      case 'TOOL':
        return 'type-tool'
      default:
        return ''
      }
    },
    getStatusClass (status) {
      switch (status) {
      case 1:
        return 'status-active'
      case 2:
        return 'status-obsolete'
      case 3:
        return 'status-hold'
      case 4:
        return 'status-locked'
      case 5:
        return 'status-released'
      default:
        return ''
      }
    },
    getStatusTooltip (status) {
      switch (status) {
      case 1:
        return 'Active'
      case 2:
        return 'Obsolete'
      case 3:
        return 'Hold'
      case 4:
        return 'Locked'
      case 5:
        return 'Released'
      default:
        return 'Unknown status'
      }
    },
    getTypeClass (status) {
      switch (status) {
      case 'Make':
        return 'type-make'
      case 'Buy':
        return 'type-buy'
      }
    },
    saveStatus (materialId, event) {
      ChangeResourceStatus(event?.target?.value, materialId)
        .then((res) => {
          success('Status Changed')
        })
        .catch(() => {
          alert('Unable to change status')
        })
    },
    openDetailModal (event, index) {
      if (
        event?.target?.tagName?.toLowerCase() === 'select' ||
        event?.target?.closest('select')
      ) {
        return
      }
      this.detailModalObject.selectedIndex = index
      this.detailModalObject.activeTab = 'details'
      this.$router.replace({
        query: {
          selectedMaterialId: this.materialMasterList[index].id,
          view: this.view
        }
      })
      this.detailModalObject.isOpen = true
    },
    closeDetailModal () {
      this.detailModalObject.isOpen = false
      this.detailModalObject.selectedIndex = -1
      this.detailModalObject.selectedMaterialObj = null
      this.detailModalObject.activeTab = 'details'
      this.$router.replace({ query: { view: this.view } })
    },
    closeWorkflowDropdown () {
      this.workFlowDropdownObject.open = false
      this.workFlowDropdownObject.index = -1
      this.workFlowDropdownObject.id = null
      this.selectedWorkFlow = null
    },
    openWorkflowDropdown (index) {
      this.workFlowDropdownObject.open = true
      this.workFlowDropdownObject.index = index
      this.workFlowDropdownObject.id = this.materialMasterList[index].id
      this.selectedWorkFlow = this.materialMasterList[index].workflow_template || null
      this.getWorkflows()
    },
    openEditModal (index) {
      this.editModalObject.isOpen = true
      this.editModalObject.selectedIndex = index
    },
    closeEditModal () {
      this.editModalObject.isOpen = false
      this.editModalObject.selectedIndex = -1
    },
    openInventoryModal (material) {
      if (material?.inventory === null || material?.inventory === undefined) {
        return
      }
      this.selectedInventoryMaterial = {
        id: material.id,
        name: material.material_name,
        inventory: material.inventory
      }
      this.showInventoryModal = true
    },
    closeInventoryModal () {
      this.showInventoryModal = false
      this.selectedInventoryMaterial = null
    },
    openMaterialObsoleteModal (index) {
      const loader = new Loader()
      loader.show()
      const productsAndBoms = {}
      GetProductsUsingMaterialQuery(this.$props.materialMasterList[index].id)
        .then((res) => {
          res.core_material_master[0].bom_material_items.forEach((item) => {
            const productCode = item.core_bom.product_bom
              ? item.core_bom.product_bom.product_code
              : ''
            if (productCode) {
              if (productsAndBoms[productCode]) {
                productsAndBoms[productCode].push(item.core_bom.name)
              } else {
                productsAndBoms[productCode] = [item.core_bom.name]
              }
            }
          })
          if (Object.keys(productsAndBoms).length) {
            this.materialObsoleteObject.isOpen = true
            this.materialObsoleteObject.selectedIndex = index
            this.materialObsoleteObject.productsAndBoms = productsAndBoms
          } else {
            const itemType = this.view === 'material' ? 'material' : 'resource'
            ConfirmationDialog(
              `Are you sure you want to make the ${itemType} <b> ${this.materialMasterList[index].material_name} </b> obsolete`,
              (res) => {
                if (res) {
                  this.materialObsoleteObject.selectedIndex = index
                  this.confirmMaterialObsolete()
                }
              }
            )
          }
        })
        .catch(() => {
          alert('Failed to fetch data')
        })
        .finally(() => {
          loader.hide()
        })
    },
    closeMaterialObsoleteModal () {
      this.materialObsoleteObject.isOpen = false
      this.materialObsoleteObject.productsAndBoms = null
      this.materialObsoleteObject.selectedIndex = -1
    },
    UpdateMaterialStatus (index, status) {
      const loader = new Loader()
      loader.show()
      const materialMasterTemp = JSON.parse(
        JSON.stringify(this.$props.materialMasterList[index])
      )
      return new Promise((resolve, reject) => {
        lifeCycleStatusUpdate({ materialId: materialMasterTemp.id, status })
          .then(() => {
            loader.hide()
            materialMasterTemp.status = status
            const itemType = this.view === 'material' ? 'material' : 'resource'
            success(`Updated ${itemType} Status`)
            materialMasterTemp.status = status
            this.$emit('updateList', {
              data: materialMasterTemp,
              index
            })
            resolve()
          })
          .catch((err) => {
            loader.hide()
            alert('Something went wrong')
            reject(err)
          })
      })
    },
    confirmMaterialObsolete () {
      this.UpdateMaterialStatus(this.materialObsoleteObject.selectedIndex, 2)
        .then(() => {
          this.closeMaterialObsoleteModal()
        })
        .catch(() => {
          const itemType = this.view === 'material' ? 'material' : 'resource'
          alert(`Unable to make ${itemType} obsolete`)
        })
    },
    openChangeStatusModal (index, status) {
      const { material_name: materialName } = this.$props.materialMasterList[index]
      const itemType = this.view === 'material' ? 'material' : 'resource'
      ConfirmationDialog(
        `Are you sure you want to ${status} the ${itemType} ${materialName}`,
        (res) => {
          if (res) {
            if (status === 'lock') {
              this.UpdateMaterialStatus(index, 4)
            } else if (status === 'unlock' || status === 'activate') {
              this.UpdateMaterialStatus(index, 1)
            }
          }
        }
      )
    },
    updateAndClose (newData) {
      this.$emit('updateList', {
        data: newData,
        index: this.editModalObject.selectedIndex
      })
      this.editModalObject.isOpen = false
      this.editModalObject.selectedIndex = -1
    },
    openDetail (docs) {
      const newDocArray = docs.map((doc) => {
        if (doc?.core_document_version) {
          return doc.core_document_version
        }

        const docVersions = doc?.core_document?.associated_versions
        if (!Array.isArray(docVersions) || docVersions.length <= 0) {
          return doc
        }
        return docVersions.at(-1) || doc
      })

      if (docs.length > 0) {
        this.detailObject = {
          open: true,
          linkedDocs: newDocArray
        }
      } else {
        alert('No documents avaiable')
      }
    },
    closeDetail () {
      this.detailObject = {
        open: false,
        fileId: ''
      }
    },
    listOfUnitOfMaterial () {
      UnitOfMaterial().then((res) => {
        this.list_of_unit_of_material = {}
        res.custom_list_values.forEach((item) => {
          this.list_of_unit_of_material[item.id] = {}
          this.list_of_unit_of_material[item.id].name = item.name
          this.list_of_unit_of_material[item.id].id = item.id
        })
      })
    },
    async MaterialList (list) {
      const materialId =
        this.$route.query.selectedMaterialId ?? this.$route.query.selectedmaterialid
      if (materialId) {
        let materialDetails = list.find((material) => material.id === materialId)
        if (!materialDetails) {
          const filter = {
            jump: 0,
            perPage: 1000,
            id: materialId
          }
          const res = await GetMaterialMasterData(filter, true)
          materialDetails = res.core_material_master[0]
        }
        this.detailModalObject.isOpen = true
        this.detailModalObject.selectedMaterialObj = materialDetails
        const queryTab = this.$route.query.activeTab
        if (queryTab && ['details', 'tags', 'history', 'workflows'].includes(queryTab)) {
          this.detailModalObject.activeTab = queryTab
        } else {
          this.detailModalObject.activeTab = 'details'
        }
      }
    },
    openAlternateModal (material, index) {
      this.selectedMaterial = {
        id: material.id,
        materialId: material.custom_material_id,
        name: material.material_name,
        product_code: material.material_product_code
          ? material.material_product_code?.product_code
          : '--',
        alternates: material.alternates || []
      }
      this.allMaterials = this.materialMasterList.filter((m) => m.id !== material.id)
      this.workflowSteps = this.getWorkflowSteps(material)
      this.showAlternateModal = true
    },
    closeAlternateModal () {
      this.showAlternateModal = false
      this.selectedMaterial = null
    },
    handleAddAlternate (materialId, payload) {
      this.closeAlternateModal()
    },
    handleViewAlternate (alternate) {
      console.log('Viewing alternate:', alternate)
    },
    handleValidationError (error) {
      this.$toast.error(error.message)
    },
    openVendorModal (data) {
      this.vendorObject.isOpen = true
      this.selectedVendor = data.material_default_vendor?.id
      if (!this.isExternalCollaborator) {
        this.vendorObject.vendorList = data.vendor_materials
      }
      this.vendorObject.materialId = data.id
      this.vendorObject.materialName = data.material_name
    },
    updateDefaultVendor () {
      const materialId = this.vendorObject.materialId
      updatedefaultVenodor(materialId, this.selectedVendor).then((res) => {
        if (res.update_core_material_master) {
          this.vendorObject.isOpen = false
          success('Default vendor updated.')
        } else {
          alert('something went wrong')
        }
      })
    },
    getWorkflowSteps (material) {
      return [
        {
          id: 1,
          name: 'Engineering Review',
          stage: 'Technical',
          duration: '2-3 days'
        },
        {
          id: 2,
          name: 'Quality Assessment',
          stage: 'QA',
          duration: '3-5 days'
        },
        {
          id: 3,
          name: 'Supply Chain Approval',
          stage: 'Procurement',
          duration: '1-2 days'
        }
      ]
    },
    openMaterialHistoryModal (index) {
      const selectedMaterial = this.materialMasterList[index]
      if (!selectedMaterial) return
      this.detailModalObject.selectedIndex = index
      this.detailModalObject.selectedMaterialObj = selectedMaterial
      this.detailModalObject.activeTab = 'history'
      this.detailModalObject.isOpen = true
      this.$router.replace({
        query: {
          selectedMaterialId: selectedMaterial.id,
          view: this.view,
          activeTab: 'history'
        }
      })
    },
    openWorkflowSelectionModal (mm, index) {
      this.wfSelectionModal = true
      this.selectedTargetStatus = null
      this.selectedMaterialForLC = mm
      this.wfSelectionLoader.skelton = true
      this.selectedMaterialForLC.index = index
      getWfListBasedOnId({ materialId: mm.id, category: Config.WORKFLOW_SUB_CATE.LIFECYCLE })
        .then((res) => {
          this.selectedMaterialForLC = mm
          this.selectedMaterialForLC.index = index
          this.workflowsData = res.get_applicable_workflows.message ?? []
          this.wfSelectionLoader.skelton = false
        })
        .catch(() => {
          this.wfSelectionLoader.skelton = false
        })
    },
    wfModalLoaderController ({ start = null, stop = null }) {
      if (start) {
        this.wfSelectionLoader.loader = true
      }
      if (stop) {
        this.wfSelectionLoader.loader = false
      }
    },
    setSelectedTargetStatus (status) {
      this.selectedTargetStatus = status
    },
    proceedWithManualStatusChange () {
      if (!this.selectedTargetStatus) {
        return alert('Invalid target status selected')
      }
      this.UpdateMaterialStatus(this.selectedMaterialForLC.index, this.selectedTargetStatus)
        .then(() => {
          this.wfSelectionModal = false
        })
        .catch((err) => {
          console.log(err)
          alert('Unable to change material status')
        })
    },
    cancelWfSelectionModal () {
      this.wfSelectionModal = false
      this.selectedMaterialForLC = {}
    },
    emitChanges (index, materialMasterTemp) {
      this.$emit('updateList', {
        data: materialMasterTemp,
        index
        // eslint-disable-next-line indent
                })
    },
    openWFInstanceModal (mm) {
      this.workflowInstanceModal = true
      this.selectedMaterialForLC = mm
    },
    finishWorkflow () {
      this.$refs.WorkflowDetailsPanel.updateWorkflowMaterial(true)
    },
    afterWFAction (closeWFT) {
      if (closeWFT) {
        this.selectedMaterialForLC.ongoing_lifecycle_workflow_id = null
      }
      this.emitChanges(this.selectedMaterialForLC.index, this.selectedMaterialForLC)
    },
    workflowCancelled (workflowMessage) {
      this.selectedMaterialForLC.ongoing_lifecycle_workflow_id = null
      const triggerUpdates = workflowMessage?.trigger_action_updates
      if (triggerUpdates) {
        const nextStatus = triggerUpdates.status ?? triggerUpdates.state
        if (nextStatus !== undefined && nextStatus !== null) {
          this.selectedMaterialForLC.status = nextStatus
        }
      }
      this.emitChanges(this.selectedMaterialForLC.index, this.selectedMaterialForLC)
      this.workflowInstanceModal = false
    },
    checkAndUpddateMaterialStatus (newStatus) {
      console.log(newStatus)
      if (!newStatus || !this.selectedMaterialForLC?.id) {
        return
      }
      this.selectedMaterialForLC.status = newStatus
    }
  },
  async mounted () {
    ResourceState().then((res) => {
      this.resourceStateValues = res.custom_list_values
    })
    this.listOfUnitOfMaterial()
  },
  watch: {
    view () {
      this.closeWorkflowDropdown()
    },
    pageNumber () {
      this.closeWorkflowDropdown()
    },
    '$route.query.selectedMaterialId' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.MaterialList(this.materialMasterList)
      }
    },
    materialMasterList: {
      immediate: true,
      handler (newList) {
        if (newList.length) {
          this.MaterialList(newList)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$status-colors: (
  active: #16A34A,
  released: #2563EB,
  obsolete: #6B7280,
  locked: #DC2626
);
.no-data-cell {
  text-align: center !important;
  font-size: var(--text-base);
  color: #6c757d;
}
.overflow-visible {
  min-width: 150px !important;
  max-width: 150px !important;
  overflow: hidden !important;
}
.action-column {
  width: 150px !important;
  white-space: nowrap;
  text-align: center;
}
.resource-action-icons {
  width: 100% !important;
  display: flex;
  justify-content: center;
}
.action-icons .is-disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.resource-action-header {
  text-align: center !important;
}
.wft {
  width: 100%;
  min-width: 0;
  flex: 1 1 0;
  &-search {
    padding: 5px 10px;
    background: white;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  &-input {
    width: 100%;
    padding: 5px 10px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    background-color: transparent;
  }
}
.workflow-link-editor {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}
.workflow-link-editor .edit {
  flex: 0 0 auto;
}
:deep(.wft.custom-dropdown-container),
:deep(.wft .custom-select) {
  width: 100%;
  max-width: none;
}
.action-column-expanded {
  min-width: 240px !important;
  max-width: 240px !important;
  width: 240px !important;
}
.workflow-modal {
  min-width: 400px;
  max-width: 500px;
}
.icon-img {
  width: 12px;
  height: 12px;
  margin-top: 1px;
}
.modal-title {
  font-size: 1.2em;
  font-weight: 500;
  color: #333;
  margin: 0;
}
.modal-subtitle {
  padding: 10px 0px 15px;
}
.vendor-card-container {
  max-height: 73vh;
  overflow: auto;
  padding-right: 11px;
}
.vendor-container {
  display: flex;
  font-size: var(--text-xs1);
  align-items: center;
  width: 100%; /* VERY IMPORTANT */
  overflow: hidden; /* hide only text overflow */
}
.vendor-card {
  display: flex;
  background-color: #f6eee4;
  border: 2.2px solid #c9a26c;
  border-radius: 8px;
  margin-top: 12px;
  padding: 15px 15px 15px 0;
}
.card-icon-check {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 24px;
}
.card-details {
  flex-grow: 1;
  padding: 0px 16px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.current-default {
  background-color: #e0f7e9;
  color: #2e7d32;
  font-size: 0.8em;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
}

.logistics-info {
  display: flex;
  gap: 30px;
  margin-bottom: 15px;
}

.logistics-item .label {
  display: block;
  font-size: 0.85em;
  color: #777;
  margin-bottom: 2px;
}

.logistics-item .value {
  display: block;
  font-size: 1.2em;
  font-weight: 700;
  color: #333;
}

/* Pricing Tiers */
.pricing-tiers .label {
  display: block;
  font-size: 0.85em;
  color: #777;
  margin-bottom: 4px;
}

.pricing-tiers .tiers-list {
  font-size: 1em;
  color: #333;
  margin: 0;
}
.type-make {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 7px;
  font-weight: 500;
  text-align: center;
  background-color: #efcaef;
  color: purple;
}
.type-buy {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 7px;
  font-weight: 500;
  text-align: center;
  background-color: #d6f6d6;
  color: #047d04;
}
.vendorName {
  padding: 3px 0;
  margin-top: 2px;
  align-items: center;
  font-size: var(--text-xs);
  color: #8c8989;
}
.editVendor {
  width: 17px;
  height: 18px;
  margin: 0px 3px;
}

.vendor-radio {
  display: flex;
  align-items: flex-start;
}

.radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #c4c4c4;
  position: relative;
}

.radio.checked {
  border-color: #c99551;
  background-color: #c99551;
}

.radio.checked::after {
  content: "✔";
  font-size: var(--text-s);
  color: #ffffff;
  font-weight: bold;
  padding: 0px 3px 0px 3px;
  position: absolute;
}

.total-count {
  background-color: #f1f3f5;
  padding: 0.5rem 0.5rem 0.5rem;
  border: 1px solid #f1f3f5;
  border-radius: 0.2em;
  width: fit-content;
  padding-inline: 10px;
  margin-left: auto;
}
.mm-table {
  th {
    z-index: 4;
  }
  .chip {
    img {
      width: 10px;
      height: 100%;
      z-index: 5;
    }
    padding: 2px 8px;
    font-size: var(--text-xs1);
    background-color: rgba(var(--brand-rgb), 0.5);
    z-index: 0;
    border-radius: 2px;
    position: relative;
    &-popover {
      position: absolute;
      width: 145px;
      height: 81px;
      background: transparent;
      /* left: -145px; */
      top: -30px;
      z-index: 4;
      display: flex;
      justify-content: start;
      transform: translateX(30%);

      & img {
        width: auto;
        height: 100%;
        object-fit: fill;
        border: 1px solid rgb(51, 40, 40, 0.5);
        border-radius: 4px;
        -webkit-box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
        box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
      }
    }
  }
  .thumbnail {
    width: 60px;
    height: 60px;
  }
}
.custom-list-select {
  max-width: 100%;
  min-width: 20%;
  // margin: 0 0 0 10px;
  margin-right: auto;
  font-size: var(--text-s);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 2px 1px;
}
.obsolete-row {
  background-color: var(--gray);
}
.material-master-table {
  height: calc(100% - 60px);
  margin-top: 10px;
  &--table {
    max-height: calc(100vh - 250px);
  }
  &--container {
    max-height: calc(100vh - 194px);
    overflow: auto;
    table {
      th,
      td {
        max-width: 100px;
        /* Set your desired max width for each column */
        overflow: hidden;
        /* Prevents content from overflowing */
        text-overflow: ellipsis;
        /* Adds ellipsis (...) for overflowing text */
        white-space: nowrap;
        border-bottom: 1px solid #e5e7eb;

        &.inventory-cell {
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            text-decoration: underline;
          }
          .inventory-link {
            cursor: pointer;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      .column {
        padding: 10px 8px;
      }
      .edit-1 {
        margin: 0 2px;
      }
    }
        & .material {
      &-name-cell {
        display: grid;
        grid-template-columns: 12px 1fr;
        grid-template-rows: 1fr 1fr;
         grid-template-areas:
            "a b"
            "a b"
            "c d"
            "c d";
          align-items: baseline;
        max-width: 100%;
        height: 100%;

     @each $name, $color in $status-colors {
  .status-#{$name} {
    background-color: $color;
      }
      }
      }
      &-status {
        grid-area: a;
        align-self: baseline;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        border: 1px solid rgba(0,0,0,0.1);
        box-shadow: 0 0 2px rgba(0,0,0,0.2);
      }
      &-name{
        grid-area: b;

      }
      &-description{
grid-area: d;
      }
    }
  }
  .pagination-footer {
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    &-total {
      margin-top: 16px;
      display: flex;
      background: #f1f3f5;
      padding: 0.5rem 0.5rem 0.5rem;
      border: 1px solid #f1f3f5;
      border-radius: 0.2em;
      width: fit-content;
      padding-inline: 10px;
      margin-left: auto;
    }
  }
  .productbom-title {
    color: var(--text-color-1);
    font-weight: 500;
    font-size: 0.9em;
  }
  .btn {
    color: var(--white);
  }
  .redColor {
    color: red;
  }
  .attachments {
    z-index: 1;
  }
}
.type-machine {
  display: inline-block;
  padding: 4px 6px;
  border-radius: 6px;
  font-weight: 500;
  text-align: center;
  font-size: 11px;
  /* Specific Colors from image */
  background-color: #f0f7ff;
  color: #004ecc;
  border: 1px solid #99c2ff;
  text-transform: uppercase;
}

.type-tool {
  display: inline-block;
  padding: 4px 6px;
  border-radius: 6px;
  font-weight: 500;
  text-align: center;
  font-size: 11px;
  /* Specific Colors from image */
  background-color: #f9f5ff;
  color: #7f56d9;
  border: 1px solid #d6bbfb;
  text-transform: uppercase;
}
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

.wf-status-action {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  min-width: 400px;

  &__title {
    margin: 0 0 10px;
    text-transform: uppercase;
    color: #64748b;
    letter-spacing: 0.6px;
    font-size: var(--text-xs2);
    font-weight: 600;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 10px;
    width: 100%;
  }

  &__btn {
    width: 100%;
    min-height: 34px;
    border-radius: 7px;
    border: 1px solid #d0d7e2;
    background: #f1f5f9;
    color: #4b5563;
    font-size: var(--text-xs1);
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  &__btn:hover {
    transform: translateY(-1px);
  }

  &__btn--active {
    border-color: #0f172a;
    background: #0f172a;
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
  }

  &__footer {
    width:100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
.modal-loader-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  z-index: 2;
}
.chip-popover {
  position: relative;
  width: 32px;
  height: 32px;
  margin-right: 8px;
  flex-shrink: 0;
  display: flex;
  top: 0;
  transform: none;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
}
.material {

  &-history {
      &-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;
& .loader-conatainer{
      min-width: 300px;
    min-height: 300px;
}
  }
    &-box {
      // -webkit-animation: slide-left 0.5s ease-in 1 alternate;
      // animation: slide-left 0.5s ease-in 1 alternate;
      width: 100%;
      height: 100%;
    }
    &-body {
      margin-top: 1.5em;
      padding: 5px;
      &-dateBox {
        display: flex;
        gap: 10px;
        align-items: center;
        font-size: 0.8em;
      }
      &-date {
        display: flex;
        align-items: center;
        gap: 5px;
        color: #b5b4b4;
      }
      &-date-line {
        flex-grow: 1;
        border: none;
        height: 0.5px;
        background-color: #cccccc81;
      }
      &-elementsBox {
        padding: 5px;
        overflow: auto;
      }
    }
  }
}
@media (max-width: 768px) {
  .wf-status-action {
    min-width:300px
    &__grid {
      grid-template-columns: 1fr;
    }
  }
}
@media (max-width: 480px) {
  .material-history-container{
    max-width: 90vw;

}
}
/* Tablets (portrait and small tablets: 481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
   .material-history-container{
max-width: 90vw;
  }
}

/* Tablets (standard: 768px - 1024px) */
@media (min-width: 768px) and (max-width: 1024px) {
  .material-history-container {
max-width: 60vw;
}
}

/* Laptops (1025px - 1280px) */
@media (min-width: 1025px)  {
.material-history-container {
max-width: 50vw;
}
}
/* Desktops (1281px - 1600px) */
@media (min-width: 1281px)  {
.material-history-container {
max-width: 40vw;
}
}
@media (min-width: 1601px) {
   .material-history-container {
max-width: 40vw;
}
}
</style>
